export default __webpack_public_path__ + "static/media/Fullscreen.51fc30c0.svg";